// extracted by mini-css-extract-plugin
export var active = "MenuEntry-module--active--3997e";
export var arrowIcon = "MenuEntry-module--arrowIcon--35c34";
export var link = "MenuEntry-module--link--5e807";
export var subEntry = "MenuEntry-module--subEntry--b963e";
export var subtitle = "MenuEntry-module--subtitle--a8e85";
export var title = "MenuEntry-module--title--731c8";
export var titleContainer = "MenuEntry-module--titleContainer--ceb2e";